<ng-container *transloco="let t">
  <div
    class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content"
    [ngClass]="lookupId"
    [formGroup]="form"
    (keydown.enter)="applyFilters()"
  >
    <div class="grid condensed-row">
      <div class="col-12 filters">
        <p-accordion>
          <p-accordionTab header="{{ t('item.item_lookup_dialog.tabs.filters') }}" [selected]="true">
            <!-- first row -->
            <div class="p-fluid grid condensed-row">
              <div class="field md:col-3 sm:col-6 col-12">
                <input
                  zTextInput
                  zAutoFocus
                  formControlName="item"
                  label="{{ t('item.item_lookup_dialog.filters.item') }}"
                  placeholder="{{ t('item.item_lookup_dialog.filters.item') }}"
                  styleClass="w-full"
                  [uppercase]="true"
                  [clearButton]="true"
                  [matchTypes]="true"
                  (matchTypeChange)="onMatchTypeChange('item', $event)"
                  defaultMatchType="startsWith"
                />
              </div>

              <div class="field md:col-3 sm:col-6 col-12">
                <z-combo-box
                  [list]="customerRateGroupDropdownList$ | async"
                  label="{{ t('item.item_lookup_dialog.filters.rategroup') }}"
                  placeholder="{{ t('item.item_lookup_dialog.filters.rategroup_select') }}"
                  fieldName="rateGroup"
                  [loading]="rateGroupLoading$ | async"
                  popupStyleClass="dialog-medium-wide"
                  [columnsConfig]="{
                    column1: { dropdown: { display: true, width: 100 }, popup: { display: true, width: 100 } },
                    column2: { dropdown: { display: true, width: 150 }, popup: { display: true, width: 150 } }
                  }"
                >
                </z-combo-box>
              </div>

              <div class="field md:col-3 sm:col-6 col-12">
                <z-combo-box
                  [list]="customerProductGroupDropdownList$ | async"
                  label="{{ t('item.item_lookup_dialog.filters.productgroup') }}"
                  placeholder="{{ t('item.item_lookup_dialog.filters.productgroup_select') }}"
                  fieldName="productGroup"
                  [loading]="productGroupLoading$ | async"
                  [columnsConfig]="{
                    column1: { dropdown: { display: true, width: 100 }, popup: { display: true, width: 100 } },
                    column2: { dropdown: { display: true, width: 150 }, popup: { display: true, width: 150 } }
                  }"
                >
                </z-combo-box>
              </div>

              <div class="field md:col-3 sm:col-6 col-12 flex justify-content-end align-self-end">
                <button
                  pButton
                  type="button"
                  icon="fad fa-check"
                  label="{{ t('item.item_lookup_dialog.filters.apply_filters') }}"
                  class="p-button-outlined"
                  (click)="applyFilters()"
                  style="width: auto"
                ></button>

                <button
                  pButton
                  type="button"
                  icon="fad fa-undo-alt"
                  label="{{ t('item.item_lookup_dialog.filters.reset') }}"
                  class="p-button-secondary p-button-outlined ml-2"
                  (click)="reset()"
                  style="width: auto"
                ></button>
              </div>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <div class="col-12 grid-table overflow-hidden">
        <z-item-lookup-dialog-grid></z-item-lookup-dialog-grid>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar" [formGroup]="form">
        <div class="p-toolbar-group-left">
          <z-legend type="form" [showHeader]="false">
            <z-legend-entry
              color="yellow"
              label="{{ t('item.item_lookup_dialog.legend.hazardous.label') }}"
              title="{{ t('item.item_lookup_dialog.legend.hazardous.title') }}"
            ></z-legend-entry>
            <z-legend-entry
              color="purple"
              label="{{ t('item.item_lookup_dialog.legend.pending.label') }}"
              title="{{ t('item.item_lookup_dialog.legend.pending.title') }}"
              styleClass="ml-1"
            ></z-legend-entry>
            <z-legend-entry
              color="grey"
              label="{{ t('item.item_lookup_dialog.legend.inactive.label') }}"
              title="{{ t('item.item_lookup_dialog.legend.inactive.title') }}"
              styleClass="ml-1"
            ></z-legend-entry>
          </z-legend>
        </div>
        <div class="p-toolbar-group-right">
          <p-button
            label="{{ t('item.item_lookup_dialog.dialog.select') }}"
            styleClass="ml-1 p-button-primary"
            (click)="onSelectClick()"
          ></p-button>
          <p-button
            label="{{ t('item.item_lookup_dialog.dialog.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="onCancelClick()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
